export default "__VITE_ASSET__B6m5eO$d__"